import { z } from 'zod'

export const PaddingSchema = z.object({
  paddingTop: z.number().nonnegative(),
  paddingRight: z.number().nonnegative(),
  paddingBottom: z.number().nonnegative(),
  paddingLeft: z.number().nonnegative(),
})

export const MarginSchema = z.object({
  marginTop: z.number(),
  marginRight: z.number(),
  marginBottom: z.number(),
  marginLeft: z.number(),
})

export const BorderWidthSchema = z.object({
  borderTopWidth: z.number().nonnegative(),
  borderRightWidth: z.number().nonnegative(),
  borderBottomWidth: z.number().nonnegative(),
  borderLeftWidth: z.number().nonnegative(),
})

export const BorderColorSchema = z.object({
  borderTopColor: z.string().nullable(),
  borderRightColor: z.string().nullable(),
  borderBottomColor: z.string().nullable(),
  borderLeftColor: z.string().nullable(),
})

export const BorderStyleValue = z.enum(['none', 'dotted', 'dashed', 'solid'])

export const BorderStyleSchema = z.object({
  borderTopStyle: BorderStyleValue,
  borderRightStyle: BorderStyleValue,
  borderBottomStyle: BorderStyleValue,
  borderLeftStyle: BorderStyleValue,
})

export const BorderSchema = z.object({
  borderWidth: BorderWidthSchema,
  borderColor: BorderColorSchema,
  borderStyle: BorderStyleSchema,
})

export const AlignSchema = z.enum(['left', 'center', 'right'])

export const AppearanceSchema = z.object({
  desktop: z.boolean(),
  mobile: z.boolean(),
})

export type PaddingType = z.infer<typeof PaddingSchema>
export type MarginType = z.infer<typeof MarginSchema>
export type BorderWidthType = z.infer<typeof BorderWidthSchema>
export type BorderColorType = z.infer<typeof BorderColorSchema>
export type BorderStyleType = z.infer<typeof BorderStyleSchema>
export type BorderType = z.infer<typeof BorderSchema>
export type BorderStyleValueType = z.infer<typeof BorderStyleValue>
export type AlignType = z.infer<typeof AlignSchema>
export type AppearanceType = z.infer<typeof AppearanceSchema>
